<script>
  export let id, fillPercentage, starConfig;
</script>

{#if fillPercentage === 1}
  <!-- Full star SVG (filled) -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={starConfig.fillColor} width="{starConfig.size}px" height="{starConfig.size}px">
    <path d="M0 0h24v24H0z" fill="none"></path>
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
  </svg>
{:else if fillPercentage === 0}
  <!-- Empty star SVG -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={starConfig.fillColor} width="{starConfig.size}px" height="{starConfig.size}px">
    <path d="M0 0h24v24H0V0z" fill="none"></path>
    <path
      d="M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"></path>
  </svg>
{:else}
  <!-- Partially filled star -->
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="{starConfig.size}px" height="{starConfig.size}px">
    <!-- Define the gradient for partial fill -->
    <defs>
      <linearGradient id="linear-gradient-{id}" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:{starConfig.fillColor};stop-opacity:1" />
        <stop offset="{fillPercentage * 100}%" style="stop-color:{starConfig.fillColor};stop-opacity:1" />
        <stop offset="{fillPercentage * 100}%" style="stop-color:{starConfig.unfilledColor};stop-opacity:1" />
      </linearGradient>
    </defs>

    <!-- First layer: partially filled star with gradient -->
    <path fill="url(#linear-gradient-{id})"
          d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>

    <!-- Second layer: empty star outline on top -->
    <path fill={starConfig.fillColor}
          d="M12 7.13l.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2L9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"></path>
  </svg>
{/if}
